import { ANALYTICS_SYNC_STATUS, type AnalyticsSyncHealth } from './analyticsTypes';

export const ANALYTICS_FRESHNESS = {
  current: 'current',
  stale: 'stale',
  unavailable: 'unavailable',
} as const;

export type AnalyticsFreshness =
  | { kind: typeof ANALYTICS_FRESHNESS.current }
  | {
      kind: typeof ANALYTICS_FRESHNESS.stale;
      lastSuccessfulSyncAt: string;
    }
  | { kind: typeof ANALYTICS_FRESHNESS.unavailable };

/** Decide whether archived reports may be described as current. */
export function selectAnalyticsFreshness(sync: AnalyticsSyncHealth): AnalyticsFreshness {
  if (sync.latest_status === ANALYTICS_SYNC_STATUS.succeeded) {
    return { kind: ANALYTICS_FRESHNESS.current };
  }
  if (sync.last_successful_sync_at !== null) {
    return {
      kind: ANALYTICS_FRESHNESS.stale,
      lastSuccessfulSyncAt: sync.last_successful_sync_at,
    };
  }
  return { kind: ANALYTICS_FRESHNESS.unavailable };
}
